module.exports = __webpack_public_path__ + "static/media/stripe.b4957216.svg";